module.exports = __webpack_public_path__ + "static/media/cnd.ca2d1910.svg";